module.exports = __webpack_public_path__ + "static/representative-355ed54c50ebd581c17c960b32b8f649.jpeg";